let fullScreen;
let fullScreenToggle = false;

// undecided if want to make this a global ' singleton ? ' kinda thing
// where there can only ever be one ' instance ' of the functionality. . .

const onFullScreen = (callback = undefined) => {
  if (!callback) {
    clearInterval(fullScreen);
    return;
  }

  fullScreen = setInterval(() => {
    if (document.fullscreen && !fullScreenToggle) {
      callback((fullScreenToggle = true));
    }

    if (!document.fullscreen && fullScreenToggle) {
      callback((fullScreenToggle = false));
    }
  }, 100);
};

export default onFullScreen;
